import { BG_TASK_TYPES } from "helpers/bgTasks";
import React from "react";
import DownloadGeneratedReportTask from "./downloadGeneratedReportTask";
import GenerateReportTask from "./generateReportTask";

const Status = ({ taskType, ...rest }) => {
    switch (taskType) {
        case BG_TASK_TYPES.GenerateReport:
            return <GenerateReportTask {...rest} />;
        case BG_TASK_TYPES.DownloadGeneratedReport:
            return <DownloadGeneratedReportTask {...rest} />;
    }
    return null;
};

export default Status;
